import Vue from "vue";
import Print from "vue-print-nb";

Vue.use(Print);
